<template>
  <main>
    <section class="demo-intro">
      <h1>Authorized Demo Centers</h1>
      <p>We are proud to have classical Pilates studio partners represent Contrology. These colleagues have agreed to welcome potential clients into their studios to “test” the Contrology Reformer at mutually convenient times, and share their own experiences.</p>
      <p>Referred to as <b>Authorized Demo Centers</b>, our partners support having options in apparatus, and believe in Jay’s adherence to Reformer specifications as he originally knew them in Joe&rsquo;s studio.</p>
      <p>If you don’t see an Authorized Demo Center near you, please use the Contact Us link in the footer for more info.</p>
    </section>
    <section class="demo-centers-container">
      <hr>
      <div class="demo-centers">

        <div class="loading" v-if="loading">
          <img src="https://s3.amazonaws.com/s3.pilates.com/img/contrology-loader.gif" alt="Stay tuned"/>
        </div>
        <div class="error" v-else-if="error">
          <p>{{ error }}</p>
        </div>
        <div v-else>
          <div class="sites-list">
            <site-card
              v-for="site in demoSites"
              :key="site._id"
              :site="site"
              class="site"
            />
          </div>
        </div>

      </div>
    </section>
  </main>
</template>

<script>
import ApiService from '@/js/ApiService.js';
import SiteCard from '@/components/SiteCard.vue';

  export default {
    name: 'democenters',

    metaInfo: {
      title: "Classical Pilates Studios - Contrology Authorized Demo Centers",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Want to demo Contrology Pilates equipment? Test out Contrology equipment at an Authorized Demo Center. Find a classical pilates studio near you now."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-adc.jpg"
        }
      ]
    },

    components: {
      SiteCard
    },

    data() {
      return {
        error: null,
        loading: false,
        sites: []
      }
    },

    computed: {
      demoSites() {
        return this.sites.filter(function(s) {
          return s.demo && s.published;
        })
      }
    },

    created() {
      this.fetchSites();
    },

    methods: {
      fetchSites() {
        this.error = null;
        this.loading = true;
        ApiService.getSites()
        .then(response => {
          this.loading = false;
          this.sites = response.data;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.error = "Sites Not Found";
        })
      },
    }
  }
</script>

<style scoped lang="scss">
hr {
  border: 0;
  border-top: 1px solid #333;
  width: 100%;
  margin-left: 0;
}

main div {
  margin: 10px 0;
}

.sites-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
}

.demo-intro p {
  font-family: var(--roboto);
  font-weight: 400;
  font-size: 1em;
  line-height: 1.5;
  color: #333;
  margin-bottom: 12px;
}

.demo-intro p:last-of-type {
  margin-bottom: 35px;
}

a {
  color: #000;
}

.loading {
  position: relative;
  top: 5%;
  left: 50%;
  transform: translateX(-16px);
}

@media only screen and (min-width:600px) {
  .demo-centers {
    margin-top: 30px;
    width: 100%;
  }
}

@media only screen and (min-width:800px) {
  .demo-intro,
  .demo-centers-container {
    margin: 0 auto;
  }
}

@media only screen and (min-width:955px) {
  .demo-intro,
  .demo-centers-container {
    max-width: 650px;
    margin: 0 auto;
  }
}
</style>
